import React, { useContext, useEffect, useState } from "react";
// import ChooseDeviceField from "./ChooseDeviceField";
import ChooseDeviceFieldSearch from "./ChooseDeviceFieldSearch";
import DeviceTypeField from "./DeviceTypeField";
import ValidationResultTableSearchSection from "../ValidationResultTableSearchSection";
//import HighlightManagement from "./HighlightManagement";
import * as deviceService from "../../devices/deviceService";
import { getFilters } from "../../view/urlService";
import { TableContext } from "../../index";
import { getAnalysisStatus } from "../ruleService";
import { ValidationStatus } from "../../vars";
import StopValidateButton from "./StopValidateButton";
import { useInterval } from "../../hooks";
// import SearchInputV2 from "../../view/SearchInputV2";
// import { useHistory } from "react-router-dom";
// import * as urlService from "../../view/urlService";

export function AnalysisTableManagement() {

    // const history = useHistory();
    const { setConfig } = useContext(TableContext);
    const [selectedDeviceTypeId, setSelectedDeviceTypeId] = useState();
    const [deviceId, setDeviceId] = useState();
    const [pageData, setPageData] = useState({});
    const [validationStatus, setValidationStatus] = useState('');
    // Initialize searchTerm from URL parameter 'rule'
    // const [searchTerm, setSearchTerm] = useState(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     return params.get('rule') || '';
    // });

    // const handleSearch = (e) => {
    //     const value = e.target.value;
    //     setSearchTerm(value);

    //     // Update URL with search parameter
    //     if (value) {
    //         history.replace({
    //             pathname: history.pathname,
    //             search: urlService.addSearchFilters('rule', value),
    //         });
    //     } else {
    //         history.replace({
    //             pathname: history.pathname,
    //             search: urlService.removeFilter('rule'),
    //         });
    //     }
    // };

    const fetchData = async () => {
        try {
            const { deviceList, deviceTypes: deviceTypeList } = await deviceService.loadAssignedDeviceTargetTypes();
            const pageFilters = getFilters(true);

            let deviceType;
            let device;

            if (pageFilters.deviceType) {
                deviceType = deviceTypeList.find(deviceType => deviceType.name === pageFilters.deviceType);

                if (pageFilters.device) {
                    device = deviceList.find(device => device.hostName === pageFilters.device);
                }
            }

            deviceType && setSelectedDeviceTypeId(deviceType.id);

            if (device) {
                setDeviceId(device.id);
            }

            setConfig(prev => ({
                ...prev,
                ...(device ? { deviceId: device.id } : {}),
                filtersLoading: false
            }));
            setPageData({ deviceList, deviceTypeList });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);

    useEffect(() => {
        updateValidationStatus();
    }, [deviceId])

    useInterval(() => updateValidationStatus(), 3500);

    const updateValidationStatus = async () => {
        if (!deviceId) {
            return;
        }
        if (deviceId < 0) {
            return;
        }
        if (!isNaN(deviceId)) {
            const result = await getAnalysisStatus(deviceId);
            //let configUpdated = false;

            if (result.status === ValidationStatus.DONE &&
                validationStatus === ValidationStatus.PROCESSING) {
                setConfig(prev => ({ ...prev, filtersLoading: false }));
            }

            if (validationStatus !== result.status) {
                setValidationStatus(result.status);
            }
        }
    }

    return (
        <div className="oct_filter-section-v2">
            {/* Row 1: Device Type & Choose Device */}
            <div className="row mb-3">
                <div className="col">
                    <label className="oct_filter-label">Device Type</label>
                    <DeviceTypeField
                        selectType={setSelectedDeviceTypeId}
                        selectedType={selectedDeviceTypeId}
                        deviceTypes={pageData.deviceTypeList}
                        setDeviceId={setDeviceId} />
                </div>
                <div className="col">
                    <label className="oct_filter-label">Choose Device</label>
                    <ChooseDeviceFieldSearch
                        selectedType={selectedDeviceTypeId}
                        setDeviceId={setDeviceId}
                        deviceId={deviceId}
                        devices={pageData.deviceList} />
                </div>
            </div>


            {/* Row 2: Filter Section */}
            <div className="mb-3">
                <label className="oct_filter-label">Filter/Search</label>
                <div>
                    <ValidationResultTableSearchSection />
                </div>
            </div>
            
            {/* Row 3: Search Section */}
            {/* <div className="mb-3">
                <div>
                    <SearchInputV2
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search by Rule Name..."
                        className=""
                    />              
                </div>
            </div> */}

            {/* Row 4: Validation Actions */}
            <div className="d-flex align-items-center gap-2">
                <StopValidateButton
                    deviceId={deviceId}
                    validationStatus={validationStatus}
                    setValidationStatus={setValidationStatus} />
                {validationStatus === ValidationStatus.PROCESSING &&
                    <span className="text-sm text-muted">Validation is already in progress.</span>
                }
            </div>
        </div>
    )

}


export default AnalysisTableManagement;
